import React from "react";
import { useWindowDimensions, ScrollView, ScrollViewProps } from "react-native";

const ScreenContainer: React.FC<ScrollViewProps> = (props) => {
    // Fetch the available window height to make it work on web, and native.
    // On web we could also use `100vh`, but that won't work on native.
    const { height: windowHeight } = useWindowDimensions();
    // Set the maximum height of the FlatList's ScrollView.
    // see: https://github.com/necolas/react-native-web/issues/1592#issuecomment-905970879
    return <ScrollView {...props} style={{ height: windowHeight }} />;
};

export default ScreenContainer;
